import { createElement } from "react";
import { NavLink } from "react-router";
import {
  Settings,
  MailQuestionMark,
  MailWarning,
  House,
  FileText,
  ShieldAlert,
  Layers3,
  History,
} from "lucide-react";
import { useUrlAssetScope, buildScopedSearch } from '@hooks';
import AccountMenu from '../AccountMenu/AccountMenu';
import styles from "./Sidebar.module.css";
import logoSvg from "../../assets/logo.svg";

const navigation = [
  ["/home", "Home", House],
  ["/inspection-suite", "Inspection Suite", ShieldAlert],
  ["/iod", "Inspection Object Database (IOD)", Layers3],
  ["/anomaly-suite", "Anomaly Suite", ShieldAlert],
  ["/report-browser", "Report Browser", FileText],
  ["/history", "Lifecycle History", History],
  ["/settings", "Settings", Settings],
  ["/contact", "Contact", MailQuestionMark],
  ["/request", "Request", MailWarning],
];

const scopedPaths = new Set([
  "/home",
  "/inspection-suite",
  "/iod",
  "/anomaly-suite",
  "/report-browser",
  "/history",
])

function Sidebar({ variant = "flat" }) {
  const { siteId, assetId } = useUrlAssetScope()

  const scopeQuery = buildScopedSearch('', {
    siteId,
    assetId,
  })

  return (
    <aside className={`${styles.sidebar} ${styles[variant]}`}>
      <div className={styles.logoContainer}>
        <p style={{ width: "100%", height: "100%" }}>
          <img className={styles.logoImage} src={logoSvg} alt="Ilosta Logo" />
        </p>
        <div className={styles.textOverlay}>
          <a
            href="https://ilosta.com"
            target="_blank"
            style={{ textDecoration: "none", color: "white" }}
          >
            <span>Ilosta</span>
          </a>
        </div>
      </div>

      <nav aria-label="Main navigation">
        {navigation.map(([path, label, _Icon]) =>
          <NavLink
            key={path}
            aria-label={label}
            title={label}
            to={{
              pathname: path,
              search: scopedPaths.has(path) && scopeQuery
                ? `?${scopeQuery}`
                : '',
            }}
            className={({ isActive }) =>
              isActive ? styles.navActive : ''}
          >
            {createElement(_Icon, { size: 19 })}
            <span>{label}</span>
          </NavLink>)}
      </nav>

      <div className={styles.accountFooter}>
        <AccountMenu placement="sidebar" />
      </div>

    </aside>
  );
}

export default Sidebar;
